'use client';
import {
  Document,
  Page,
  StyleSheet,
  Text,
  View
} from '@react-pdf/renderer';
import Header from './Header';
import Footer from './Footer';
import dayjs from 'dayjs';

const primaryColor = "#3778C2";
const lightGray = "#F3F6FA";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    fontFamily: "Helvetica",
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 40,
    paddingRight: 40,
    lineHeight: 1.5,
    flexDirection: "column",
  },
  eventTitle: {
    fontSize: 26,
    color: primaryColor,
    textAlign: "center",
    marginBottom: 6,
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  subtitle: {
    textAlign: "center",
    fontSize: 12,
    color: "#555",
    marginBottom: 20,
    marginTop: 10,
  },
  sectionHeader: {
    fontSize: 14,
    color: "#fff",
    backgroundColor: primaryColor,
    padding: 6,
    fontWeight: "bold",
    marginTop: 15,
    marginBottom: 8,
    borderRadius: 2,
  },
  infoRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 6,
  },
  infoLabel: {
    color: "#333",
    fontWeight: "bold",
  },
  infoValue: {
    color: "#555",
  },
  tableContainer: {
    borderWidth: 1,
    borderColor: primaryColor,
    borderRadius: 3,
    marginTop: 10,
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: primaryColor,
    color: "#fff",
    fontWeight: "bold",
    textAlign: "center",
  },
  headerTitle: {
    width: "30%",
    padding: 6,
    fontSize: 11,
    borderRightWidth: 1,
    borderRightColor: "#fff",
  },
  headerDescription: {
    width: "70%",
    padding: 6,
    fontSize: 11,
  },
  row: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#E5E5E5",
  },
  titleCell: {
    width: "30%",
    padding: 6,
    fontSize: 10.5,
    color: "#333",
    fontWeight: "bold",
    backgroundColor: lightGray,
    borderRightWidth: 1,
    borderRightColor: "#E5E5E5",
  },
  descCell: {
    width: "70%",
    padding: 6,
    fontSize: 10.5,
    color: "#444",
  },
});

const Wedding = ({ pdfData, mob_no_status }) => {
  const eventDateString = pdfData?.event_date || "";
  const cleanedString = eventDateString.replace(/[{}"]/g, "");
  const eventDates = cleanedString ? cleanedString.split(",") : [];
  const selectedEvents = pdfData?.event_options?.filter(e => e.isSelected) || [];
  const selectedServices = pdfData?.service_option?.filter(s => s.isSelected) || [];
  const selectedVenues = pdfData?.venue_options?.filter(v => v.isSelected) || [];
  const decorTheme = pdfData?.decor_theme?.label || "N/A";
  const maskMobile = (number) => {
    if (!number || number.length < 6) return number;
    return number.slice(0, number.length - 6) + '**';
  };
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Title */}
        <Text style={styles.eventTitle}>Wedding Quotation</Text>
        <Text style={styles.subtitle}>Plan your dream celebration with us</Text>

        {/* Header */}
        <Header />

        {/* Client Details */}
        <Text style={styles.sectionHeader}>Client Details</Text>
        <View style={styles.infoRow}>
          <Text style={styles.infoLabel}>Contact Person:</Text>
          <Text style={styles.infoValue}>{pdfData?.name || "N/A"}</Text>
        </View>
        <View style={styles.infoRow}>
          <Text style={styles.infoLabel}>Mobile Number:</Text>
          <Text style={styles.infoValue}>{mob_no_status ? pdfData?.mob_no : maskMobile(pdfData?.mob_no)}</Text>
        </View>
        {pdfData?.preferred_location && (
          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Location:</Text>
            <Text style={styles.infoValue}>{pdfData?.preferred_location?.label || 'Na'}</Text>
          </View>
        )}
        <View style={styles.infoRow}>
          <Text style={styles.infoLabel}>Groom Name:</Text>
          <Text style={styles.infoValue}>{pdfData?.groom_name || "N/A"}</Text>
        </View>
        <View style={styles.infoRow}>
          <Text style={styles.infoLabel}>Bride Name:</Text>
          <Text style={styles.infoValue}>{pdfData?.bride_name || "N/A"}</Text>
        </View>

        {/* Event Details */}
        {/* <Text style={styles.sectionHeader}>Event Details</Text> */}
        <View style={styles.tableContainer}>
          <View style={styles.tableHeader}>
            <Text style={styles.headerTitle}>Title</Text>
            <Text style={styles.headerDescription}>Description</Text>
          </View>

          {selectedEvents.length > 0 && (
            <View style={styles.row}>
              <Text style={styles.titleCell}>Event Types & Pax</Text>
              <Text style={styles.descCell}>
                {selectedEvents.map((e, i) =>
                  `${e.name} (${e.pax || 0} Pax)` +
                  (i !== selectedEvents.length - 1 ? ", " : "")
                )}
              </Text>
            </View>
          )}

          {eventDates.length > 0 && (
            <View style={styles.row}>
              <Text style={styles.titleCell}>Event Dates</Text>
              <Text style={styles.descCell}>
                {eventDates.map((date, i) =>
                  dayjs(date * 1000).format("DD MMM, YYYY") +
                  (i !== eventDates.length - 1 ? ", " : "")
                )}
              </Text>
            </View>
          )}

          {pdfData?.event_budget && (
            <View style={styles.row}>
              <Text style={styles.titleCell}>Event Budget</Text>
              <Text style={styles.descCell}>{pdfData.event_budget}</Text>
            </View>
          )}

          <View style={styles.row}>
            <Text style={styles.titleCell}>Food Type</Text>
            <Text style={styles.descCell}>{pdfData?.food_type || "N/A"}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.titleCell}>Menu Price</Text>
            <Text style={styles.descCell}>{pdfData?.menu_price || "N/A"}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.titleCell}>Number of Rooms</Text>
            <Text style={styles.descCell}>{pdfData?.no_of_room || "N/A"}</Text>
          </View>
          {
                        pdfData?.decor_required && (
                            <View style={styles.row}>
                                <Text style={styles.titleCell}>Decor Theme</Text>
                                <Text style={styles.descCell}>{decorTheme}</Text>
                            </View>
                        )
                    }

          {selectedServices.length > 0 && (
            <View style={styles.row}>
              <Text style={styles.titleCell}>Additional Requirements</Text>
              <Text style={styles.descCell}>
                {selectedServices.map((s, i) =>
                  s.name + (i !== selectedServices.length - 1 ? ", " : "")
                )}
              </Text>
            </View>
          )}

          {selectedVenues.length > 0 && (
            <View style={styles.row}>
              <Text style={styles.titleCell}>Venue Type</Text>
              <Text style={styles.descCell}>
                {selectedVenues.map((v, i) =>
                  v.name + (i !== selectedVenues.length - 1 ? ", " : "")
                )}
              </Text>
            </View>
          )}

          {pdfData?.notes && (
            <View style={styles.row}>
              <Text style={styles.titleCell}>Notes</Text>
              <Text style={styles.descCell}>{pdfData.notes}</Text>
            </View>
          )}
        </View>

        {/* Footer */}
        <Footer />
      </Page>
    </Document>
  );
};

export default Wedding;